import React from 'react';
import Pro01 from "../../images/services/mm/Solving-Problems-Efficiently-With-MMS.webp";
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Efficiently">
                            <h2>Solving Problems Efficiently With MMS</h2>
                        </div>
                        <p>Managed mobility solutions (MMS) deliver the utmost value when executed correctly. From building the trust to following the process to achieve tactical excellence, we leave no stone unturned to make our solutions work for you. We take care of all the devices and systems by keeping track and ensuring multi-faceted brilliance to make every project sustainable in the long term. Our agile process delivers value, peace, and ultimate efficiency, which goes a long way.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">17+<span>projects completed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">17+<span>businesses served</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">6+<span>industries covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;